import { Component, Input, OnInit } from "@angular/core";
import { AuthService } from "../../services/auth.service";
import { Router } from "@angular/router";
import { Link, StaticMethods } from "../../model/GeneralModels";
import { AppSettingsService } from "../../services/app-settings.service";

@Component({
  selector: "app-main-nav-bar",
  template: `
    <div id="wrapper" style="padding-top:10px" class="">
      <nav class="navbar navbar-white bg-white justify-content">
        <a
          class="navbar-b"
          style="margin-right: 5px;margin-left: 2px;"
          href="tel:+98218943"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
            version="1.1"
            id="Capa_1"
            x="0px"
            y="0px"
            viewBox="0 0 512 512"
            style="enable-background:new 0 0 512 512;margin:17px"
            xml:space="preserve"
            width="30"
            height="20"
            class=""
          >
            <g>
              <g>
                <g>
                  <g>
                    <path
                      d="M120,203H80.481C87.157,112,163.326,40,256,40c73.334,0,139.692,46.19,165.125,114.939     c3.832,10.359,15.336,15.65,25.697,11.819c10.359-3.833,15.651-15.337,11.819-25.697c-15.158-40.976-42.087-76.04-77.874-101.402     C344.157,13.714,301.013,0,256,0c-57.695,0-111.938,22.468-152.735,63.265C63,103.53,40.605,156.894,40.027,213.747     C16.125,227.597,0,253.443,0,283v68c0,44.112,35.888,80,80,80h40c11.046,0,20-8.954,20-20V223C140,211.954,131.046,203,120,203z      M100,391H80c-22.056,0-40-17.944-40-40v-68c0-22.056,17.944-40,40-40h20V391z"
                      data-original="#000000"
                      class="active-path"
                      style="fill:#c8141e"
                      data-old_color="#000000"
                    />
                    <path
                      d="M432,203h-40c-11.046,0-20,8.954-20,20v137v51v21c0,11.028-8.972,20-20,20h-61v0.634     C284.178,440.331,271.064,432,256,432c-22.091,0-40,17.909-40,40s17.909,40,40,40c15.064,0,28.178-8.331,35-20.634V492h61     c33.084,0,60-26.916,60-60v-1h20c44.112,0,80-35.888,80-80v-68C512,238.888,476.112,203,432,203z M472,351     c0,22.056-17.944,40-40,40h-20v-31V243h20c22.056,0,40,17.944,40,40V351z"
                      data-original="#000000"
                      class="active-path"
                      style="fill:#c8141e"
                      data-old_color="#000000"
                    />
                  </g>
                </g>
              </g>
            </g>
          </svg>
        </a>
        <!--3-->
        <div
          class="form-inline"
          style="  display: flex;
  align-items: center;
  justify-content: center;"
        >
          <!-- <button *ngIf="!mobile" (click)="login()" class="btn btn-danger login-button">
            ورود/عضویت
          </button> -->
          <img
            src="assets/images/logo.png"
            alt="samaninsurance"
            width="190"
            height="60"
          />
          <button
            *ngIf="mobile"
            mat-button
            [matMenuTriggerFor]="loggedInMenu"
            style="margin-right: auto"
            class="btn login-button home-page "
            title="{{ mobile }}"
          >
            {{ mobile }} <i class="lnr lnr-users"></i>
          </button>
          <mat-menu #loggedInMenu="matMenu" xPosition="after">
            <!--                <button mat-menu-item [routerLink]="'/profile'">پروفایل</button>-->
            <button
              mat-menu-item
              *ngIf="myRequestsURL"
              routerLink="{{ myRequestsURL }}"
            >
              بیمه های من
            </button>
            <button mat-menu-item routerLink="/logout" [state]="history">
              خروج
            </button>
          </mat-menu>
        </div>
      </nav>
      <!-- <nav class="navbar navbar-light bg-light justify-content-between" style="box-shadow: 0 0 9px 0px gray; text-align: center">
        <span class="navbar-c">
          <img src="assets/images/logo.png" alt="hashtagbime" width="142" height="42">
        </span>
      </nav> -->
    </div>
  `,
  styleUrls: [
    "../../assets/css/light.theme.css",
    "../../assets/css/navbar.css",
  ],
  styles: [
    `
      ::ng-deep .mat-menu-content {
        min-width: 130px !important;
      }

      .navbar {
        margin-bottom: 15px;
      }

      .login-button {
        background-color: #14317a ;
        border-radius: 8px;
        margin-left: 5px;
        width: 89px;
        height: 33px;
        line-height: 32px;
        padding: 0 8px !important;
        font-weight: normal;
        min-width: fit-content !important;
      }
    `,
  ],
})
export class MainNavBarComponent implements OnInit {
  mobile = "";
  role: string;
  state: {
    mobile: string;
    role: string;
  };
  history: any;
  myRequestsURL: string;
  linksList: Link[] = [];

  constructor(
    private authService: AuthService,
    private router: Router,
    private settings: AppSettingsService
  ) {}

  ngOnInit() {
    this.history = history;
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
    this.state = history.state;
    this.role = this.state.role || StaticMethods.getRole(this.router.url);
    this.mobile =
      this.authService.decode() && this.authService.decode().Role === this.role
        ? this.authService.decode().auth
        : "";
    this.getLinksList();
  }

  onScroll() {
    const mainNavbarElement = document.getElementById("main-nav-bar");
    const numberLinkElement = document.getElementById(
      "phone-number-a-link-item"
    );
    const numberElement = document.getElementById("phone-number");
    // document.body.scrollTop = 0; // For Safari
    // document.documentElement.scrollTop = 0;
    window.onscroll = () => {
      const currentScrollPos = window.pageYOffset;
      if (currentScrollPos > 10) {
        mainNavbarElement.style.backgroundColor = "#FFF";
        mainNavbarElement.style.height = "60px";
        mainNavbarElement.style["box-shadow"] =
          "0 8px 20px 0 rgba(8, 8, 8, .3)";
        numberLinkElement.style.backgroundColor = "#294187";
        numberElement.style.color = "#fff";
      } else {
        mainNavbarElement.style.backgroundColor = "transparent";
        mainNavbarElement.style.height = "80px";
        mainNavbarElement.style["box-shadow"] = "none";
        numberLinkElement.style.backgroundColor = "#fff";
        numberElement.style.color = "lightblue";
      }
    };
  }

  login() {
    const url = this.router.url;
    this.state.role = this.role;
    this.router.navigate(["/login"], {
      queryParams: {
        returnUrl: url,
      },
      state: this.state,
    });
  }

  getLinksList() {
    const productName = StaticMethods.getProductName(this.router, false);
    const applicationUrl = "/" + (StaticMethods.getBaseUrl(productName) || "");
    console.log("homeUrl ", applicationUrl);
    console.log("router.url ", this.router.url);
    this.myRequestsURL =
      productName !== "NOT_SET" ? `/${productName}/requests` : null;
    this.linksList = [];
    // this.linksList[this.linksList.length] = new Link('خانه', '/', 'lnr-home');
    if (applicationUrl !== "/") {
      this.linksList[this.linksList.length] = new Link(
        this.settings.translateEnglish(productName),
        applicationUrl,
        this.settings.getIcon(productName)
      );
    }
    switch (productName) {
      case "HEALTH":
        break;
      case "INDIVIDUAL_ACCIDENTS":
        break;
      case "MOBILE":
        break;
    }
  }
}
